import { render, staticRenderFns } from "./TrsImport.vue?vue&type=template&id=07fa022d"
import script from "./TrsImport.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrsImport.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports